(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elite-rental-hero"] && !Shopify.designMode) return;
  try {
    
customElements.whenDefined('slideshow-component').then(() => {
  if (customElements.get('elite-vehicle-carousel')) return;
  const NativeSlideshow = customElements.get('slideshow-component');
  class EliteVehicleCarousel extends NativeSlideshow {
    connectedCallback() {
      if (this.eliteReady) return;
      this.eliteReady = true;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        this.allowMotion = false;
        if (this.motionPreference.matches) {
          this.autoplayButtonIsSetToPlay = false;
          this.pause();
          if (this.sliderAutoplayButton) this.togglePlayButtonState(true);
        }
      };
      this.onVisibilityChange = () => {
        if (document.hidden) this.pause();
        else if (this.autoplayButtonIsSetToPlay) this.play();
      };
      this.onCarouselKey = (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        (event.key === 'ArrowLeft' ? this.prevButton : this.nextButton).click();
      };
      this.motionPreference.addEventListener('change', this.onMotionChange);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.addEventListener('keydown', this.onCarouselKey);
      this.onMotionChange();
    }
    disconnectedCallback() {
      this.pause();
      this.motionPreference?.removeEventListener('change', this.onMotionChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.removeEventListener('keydown', this.onCarouselKey);
      this.eliteReady = false;
    }
    play() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if ((reduced && !this.allowMotion) || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) {
        super.pause();
        return;
      }
      super.play();
    }
    autoPlayToggle() {
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
      this.allowMotion = this.autoplayButtonIsSetToPlay;
      this.togglePlayButtonState(!this.autoplayButtonIsSetToPlay);
      if (this.autoplayButtonIsSetToPlay) this.play();
      else this.pause();
    }
    focusInHandling() { this.pause(); }
    focusOutHandling() {
      queueMicrotask(() => { if (this.autoplayButtonIsSetToPlay) this.play(); });
    }
  }
  customElements.define('elite-vehicle-carousel', EliteVehicleCarousel);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
